(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stanza-sticky-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stanza-sticky-product')) {
    customElements.define('stanza-sticky-product', class extends HTMLElement {
      connectedCallback() {
        const info = document.getElementById(`ProductInfo-${this.dataset.section}`);
        if (!info || !('IntersectionObserver' in window)) return;
        const original = info.querySelector('.product-form__buttons');
        if (!original) return;
        this.visibilityObserver = new IntersectionObserver(entries => {this.hidden = entries[0].isIntersecting;});
        this.visibilityObserver.observe(original);
        const submit = this.querySelector('[data-sticky-submit]');
        const sync = () => {
          const source = info.querySelector('.product-form__submit');
          if (submit) submit.disabled = !source || source.disabled;
          const price = info.querySelector('.price .price-item--sale') || info.querySelector('.price .price-item--regular');
          const target = this.querySelector('[data-sticky-price]');
          if (price && target.textContent !== price.textContent.trim()) target.textContent = price.textContent.trim();
        };
        if (submit) submit.addEventListener('click', () => {
          const source = info.querySelector('.product-form__submit');
          if (source && !source.disabled) source.click();
        });
        this.productObserver = new MutationObserver(sync);
        this.productObserver.observe(info, {childList:true,subtree:true,attributes:true,attributeFilter:['disabled']});
        sync();
      }
      disconnectedCallback() {
        this.visibilityObserver?.disconnect();
        this.productObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
